import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { Button } from "@odingard/design-system";
import { useAuth } from "../lib/auth";

export const COMPANY_SITE_URL = "https://www.odingard.com";
// Products Studio does not provision are sold from the corporate site.
export const TRACELOCK_URL = `${COMPANY_SITE_URL}/tracelock`;

const NAV = [
  { to: "/marketplace", label: "Marketplace" },
  { to: "/pricing", label: "Pricing" },
  { to: "/solutions", label: "Solutions" },
  { to: "/security", label: "Security" },
  { to: "/resources", label: "Resources" },
  { to: "/contact", label: "Contact" },
];

export function MarketingLayout() {
  const [open, setOpen] = useState(false);
  const { user, activeOrg } = useAuth();
  const { pathname } = useLocation();

  // A router navigation keeps the scroll position, so a footer link from the
  // bottom of one page opened the next one halfway down it.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <header className="site-header">
        <div className="container site-header__inner">
          <Link to="/" className="brand">
            <img className="brand__logo" src="/odingard-logo.png" alt="Odingard" /> <span className="brand__suffix">Studio</span>
          </Link>
          <nav className={`site-nav ${open ? "site-nav--open" : ""}`} aria-label="Primary">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}>
                {n.label}
              </NavLink>
            ))}
            {/* On a phone the header has room for one action, so sign in moves
                into the menu rather than sitting on top of the wordmark. */}
            {!(user && activeOrg) && (
              <NavLink className="site-nav__signin" to="/login" onClick={() => setOpen(false)}>
                Sign in
              </NavLink>
            )}
          </nav>
          <div className="site-header__cta">
            {user && activeOrg ? (
              // Signed-in visitors keep browsing the storefront; the workspace is
              // one click away rather than a forced redirect.
              <Link to="/studio">
                <Button size="sm">Go to workspace</Button>
              </Link>
            ) : (
              <>
                <Link to="/login" className="site-header__signin">
                  <Button variant="ghost" size="sm">
                    Sign in
                  </Button>
                </Link>
                <Link to="/start">
                  <Button size="sm">Start free trial</Button>
                </Link>
              </>
            )}
            <button
              className="nav-toggle ods-btn ods-btn--ghost ods-btn--sm"
              aria-label="Toggle navigation"
              aria-expanded={open}
              onClick={() => setOpen((o) => !o)}
            >
              ☰
            </button>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="container site-footer__grid">
          <div>
            <Link to="/" className="brand">
              <img className="brand__logo" src="/odingard-logo.png" alt="Odingard" /> <span className="brand__suffix">Studio</span>
            </Link>
            <p style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)", maxWidth: 280 }}>
              Governed AI applications for regulated enterprises. They fail closed, isolate every tenant, and keep evidence ready for audit.
            </p>
          </div>
          <div>
            <h4>Product</h4>
            <Link to="/marketplace">Marketplace</Link>
            <Link to="/contract-ai">Contract AI</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/solutions">Solutions</Link>
          </div>
          <div>
            <h4>Company</h4>
            <a href={COMPANY_SITE_URL}>odingard.com</a>
            <Link to="/about">About</Link>
            <Link to="/customers">Customers</Link>
            <Link to="/security">Security &amp; Trust</Link>
            <Link to="/resources">Resources</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div>
            <h4>Get started</h4>
            <Link to="/login">Sign in</Link>
            <Link to="/start">Start free trial</Link>
          </div>
        </div>
        <div className="container" style={{ marginTop: "var(--ods-space-6)", color: "var(--ods-color-muted)", fontSize: "var(--ods-text-xs)" }}>
          © {new Date().getFullYear()} Odingard Studio. All rights reserved.
        </div>
      </footer>
    </>
  );
}
